import { useState } from 'react';
import { Heart } from 'lucide-react';
import { patientApi } from '../api';

interface FavoriteButtonProps {
  providerId: string;
  initialFavorited?: boolean;
}

export default function FavoriteButton({ providerId, initialFavorited = false }: FavoriteButtonProps) {
  const [favorited, setFavorited] = useState(initialFavorited);
  const [busy, setBusy] = useState(false);

  const toggle = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      if (favorited) {
        await patientApi.removeFavorite(providerId);
        setFavorited(false);
      } else {
        await patientApi.addFavorite(providerId);
        setFavorited(true);
      }
    } catch {
      // silent — keep current state
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      className={`p-2 rounded-xl transition-colors ${
        favorited
          ? 'bg-red-50 text-red-500 hover:bg-red-100'
          : 'bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-gray-600'
      } ${busy ? 'opacity-50' : ''}`}
      title={favorited ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Heart className={`w-5 h-5 ${favorited ? 'fill-red-500' : ''}`} />
    </button>
  );
}
